import React from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../style/Palettes'

const BarContainer = styled.div`
  height: ${p => p.height + 'px'};
  width: ${p => p.width + 'px'};
  background: ${p => p.theme.palette.neutralLighter};

  @media print {
    background: ${defaultTheme.palette.neutralLighter};
  }
`

const FilledBar = styled.div`
  height: 100%;
  width: ${p => p.progress + '%'};
  background: ${p => p.theme.palette.themePrimary};

  @media print {
    background: ${defaultTheme.palette.themePrimary};
  }
`

export const ProgressBar = ({ width = 32, height = 5, progress, ...rest }) => {
  return (
    <BarContainer width={width} height={height} {...rest}>
      <FilledBar progress={progress} />
    </BarContainer>
  )
}
